import MDTypography from "@/components/atoms/MDTypography";
import { IMedia } from "@/interfaces/media.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

import AudioMedia from "./audioMedia";
import ButtonMedia from "./buttonMedia";
import ContactsMedia from "./contactsMedia";
import DocumentMedia from "./documentMedia";
import ImageMedia from "./imageMedia";
import StickerMedia from "./stickerMedia";
import TextMedia from "./textMedia";
import VideoMedia from "./videoMedia";

interface MediaComponentProps {
  mediaType?: string;
  mediaURL: string;
  media: IMedia;
  messages: CurrentChatMessages;
  isSentByUser: boolean;
}

const MediaComponent: React.FC<MediaComponentProps> = ({
  mediaType,
  mediaURL,
  media,
  messages,
  isSentByUser,
}) => {
  switch (mediaType) {
    case "video":
      return <VideoMedia media={media} mediaURL={mediaURL} />;
    case "image":
      return <ImageMedia media={media} mediaURL={mediaURL} messages={messages} />;
    case "audio":
      return <AudioMedia media={media} mediaURL={mediaURL} isSentByUser={isSentByUser} />;
    case "document":
      return (
        <DocumentMedia
          media={media}
          mediaURL={mediaURL}
          messages={messages}
          isSentByUser={isSentByUser}
        />
      );
    case "button":
      return <ButtonMedia media={media} messages={messages} />;
    case "sticker":
      return <StickerMedia media={media} mediaURL={mediaURL} />;
    case "text":
      return <TextMedia media={media} />;
    case "contacts":
      return <ContactsMedia media={media} />;
    default:
      return <MDTypography variant="body2">Unsupported Media</MDTypography>;
  }
};

export default MediaComponent;
